module.exports = __webpack_public_path__ + "static/easily-collect-and-verify-timesheets-2a210e18ec7ab6c88961a251cf05bf3c.png";